import Loader from "components/shared/loader";
import { authProvidersEnum } from "helpers/enums";
import { paths } from "helpers/paths";
import { useRouter } from "hooks/useRouter";
import React, { useEffect, useState } from "react";
import { authorizeExternal, linkExternalAccount } from "sources/account";

type AtiSuCallbackProps = {
    isAuthenticated: boolean;
};

export default function AtiSuCallback({ isAuthenticated }: AtiSuCallbackProps) {
    const router = useRouter();
    const [error, setError] = useState("");

    useEffect(() => {
        const code = router.query.code;

        if (!code) {
            setError("ATI.SU не передал код авторизации.");
            return;
        }

        let isMounted = true;

        const processCallback = async () => {
            if (isAuthenticated) {
                const response = await linkExternalAccount({ provider: authProvidersEnum.AtiSu, code });

                if (!response.success) {
                    if (isMounted) {
                        setError(response.message || "Не удалось подключить ATI.SU.");
                    }
                    return;
                }

                window.location.replace(paths.integrationItem("atisu"));
                return;
            }

            const response = await authorizeExternal({ provider: authProvidersEnum.AtiSu, code });
            if (!response || response.status === "error") {
                if (isMounted) {
                    setError(response?.message || "Не удалось авторизоваться через ATI.SU.");
                }
                return;
            }

            const targetPath = response.currentUser?.organizationId ? paths.root : paths.registrationAtiSu;
            window.location.replace(targetPath);
        };

        processCallback().catch(() => {
            if (isMounted) {
                setError(isAuthenticated ? "Не удалось подключить ATI.SU." : "Не удалось авторизоваться через ATI.SU.");
            }
        });

        return () => {
            isMounted = false;
        };
    }, [isAuthenticated, router.query.code]);

    const returnPath = isAuthenticated ? paths.integrationItem("atisu") : paths.registration;

    return (
        <div className="no-overflow h-100">
            <div className="identity-container">
                <div className="identity-container__shadow" />
                <div className="identity-container__background" />
                <div className="identity-panel identity-panel--small">
                    <div className="identity-column text-center">
                        <h1 className="identity-container__title" />
                        {error ? (
                            <div className="px-3 w-100">
                                <div className="identity-column__title mb-3 text-center">
                                    {isAuthenticated ? "Не удалось подключить ATI.SU" : "Не удалось войти"}
                                </div>
                                <p className="mb-3">{error}</p>
                                <button
                                    className="identity-form__button identity-form__button--yellow"
                                    type="button"
                                    onClick={() => window.location.replace(returnPath)}
                                >
                                    {isAuthenticated ? "Вернуться к интеграции" : "Вернуться к регистрации"}
                                </button>
                            </div>
                        ) : (
                            <>
                                <div className="identity-column__title mb-3">
                                    {isAuthenticated
                                        ? "Выполняется подключение ATI.SU"
                                        : "Выполняется вход через ATI.SU"}
                                </div>
                                <Loader />
                            </>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
}
